export const NEW_BENEFICIARY_KEYWORD = 'NEW';
